import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SignIn from './pages/SignIn';
import SignOff from './pages/SignOff';
import SignUp from './pages/SignUp';
import SignUpConfirm from './pages/SignUpConfirm';
import VerifyAccount from './pages/VerifyAccount';
import ForgotPassword from './pages/ForgotPassword';
import UpdatePassword from './pages/UpdatePassword';
import UpdateProfile from './pages/UpdateProfile';
import AllPages from './pages/AllPages';
import GoogleCallback from './pages/GoogleCallback';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/update-profile" element={<UpdateProfile />} />
        <Route path="/google-callback" element={<GoogleCallback />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/sign-off" element={<SignOff />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/sign-up-confirm" element={<SignUpConfirm />} />
        <Route path="/verify-account" element={<VerifyAccount />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/update-password" element={<UpdatePassword />} />
        <Route path="/all" element={<AllPages />} />
        <Route path="/" element={<SignIn />} />
        <Route path="*" element={<Navigate to="/sign-in" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
